import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { LoginLogoComponent } from 'projects/components/page-components/login-logo/login-logo.component';

@Component({
  selector: 'pay-login-logout',
  imports: [TranslatePipe, LoginLogoComponent],
  templateUrl: './logout.component.html',
})
export class LogoutComponent {}
